import { usePermission } from '@circlefin/permissions/react'
import { CUSTODY_POLICY_SECTION } from '@services/permissions'
import { PayoutCard } from '@shared/components/common'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import {
  usePayoutQuery,
  useWalletApprovalTransactionDetailByJobIdQuery,
} from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { FxTransactionHeading } from '../../components'
import { WalletApprovalTransactionDetailApprovalSummary } from '../WalletApprovalTransactionDetailApprovalSummary/WalletApprovalTransactionDetailApprovalSummary'

export interface FxPayoutDetailProps {
  /**
   * Payout Transaction ID.
   */
  id: string
}

export const FxPayoutDetail: React.FC<FxPayoutDetailProps> = ({ id }) => {
  const { t } = useTranslation('payments')
  const [, { isAuthorized }] = usePermission(CUSTODY_POLICY_SECTION)

  const { data, loading, error, refetch } = usePayoutQuery({
    variables: {
      id,
    },
  })

  const walletApproval = useWalletApprovalTransactionDetailByJobIdQuery({
    variables: {
      jobId: data?.payout.id ?? '',
    },
    skip: !isAuthorized || !data?.payout.id,
  })

  return (
    <GraphQLErrorBoundary error={error} retry={refetch}>
      <FxTransactionHeading
        loading={loading}
        title={t`fxTransactionDetail.title.payout`}
        transaction={data?.payout}
      />
      <PayoutCard loading={loading} payout={data?.payout}>
        {walletApproval.data?.walletApprovalTransactionDetailByJobId && (
          <WalletApprovalTransactionDetailApprovalSummary
            {...walletApproval.data.walletApprovalTransactionDetailByJobId}
            loading={walletApproval.loading}
          />
        )}
      </PayoutCard>
    </GraphQLErrorBoundary>
  )
}
